export default __webpack_public_path__ + "static/media/linkedin.0c279afe.svg";